import './Shared/FrameModules/Image/moocrop.js';
import './Shared/FrameModules/Image/image_crop.js';
import '../../../../3P/FileDrop/filedrop.js';
import './Shared/FrameModules/MediaLibrary/library.js';
import '../../../../3P/javascript-state-machine/state-machine.js';
import '../../../../3P/strict-object/lib/strictObject.js';
import './Shared/FrameModules/MediaLibrary/item.js';
import './Shared/FrameModules/MediaLibrary/target.js';
import './Shared/FrameModules/MediaLibrary/text_target.js';
import './Shared/FrameModules/MediaLibrary/minimal_target.js';
import './Shared/FrameModules/Image/moocanvas.js';
import './Shared/FrameModules/MediaLibrary/media_manager.js';
import './Shared/FrameModules/MediaLibrary/item_menu.js';
import './Shared/FrameModules/MediaLibrary/item_image.js';
import './Shared/FrameModules/MediaLibrary/item_document.js';
import './Shared/FrameModules/MediaLibrary/video_item.js';
import './Shared/FrameModules/MediaLibrary/item_embed.js';
import './FrameModules/wiki_image.js';
import './FrameModules/Sidebar/wiki_related.js';
import './FrameModules/Sidebar/wiki_help.js';
import './FrameModules/user_like.js';
import './FrameModules/user_flags.js';
import './FrameModules/user_feedback.js';
import './FrameModules/team_profile.js';
import './FrameModules/Sidebar/author_edit.js';
import './FrameModules/tags_edit.js';
import './FrameModules/single_field_editor.js';
import './FrameModules/Sidebar/guide_work_log_settings.js';
import './FrameModules/comments_watch.js';
import './FrameModules/Sidebar/step_list_edit.js';
import './FrameModules/patrol_threshold.js';
import './FrameModules/Sidebar/topic_hierarchy.js';
import './FrameModules/comments.js';
import './FrameModules/moderator_vote.js';
import './FrameModules/message_user.js';
import './FrameModules/Sidebar/guide_publish.js';
import './Shared/user_finder.js';
import './Shared/team_finder.js';
